import { ReactNode } from "react";

import { clsx } from "clsx";

import styles from "./BlockContent.module.scss";

type BlockContentProps = {
    children?: ReactNode;
    className?: string;
    isActive: boolean;
};

// this component is very strange.
// while working on IVR we should take some time
// and figure out if we can make this more useful and
// and back fill it to journeys
export function BlockContent({ children, className = "", isActive = false }: BlockContentProps): JSX.Element {
    return (
        <div
            data-testid="block-content"
            className={clsx(styles.nodeContent, className, {
                [styles.inActiveNode]: !isActive,
            })}
        >
            <div className="flex-column">{children}</div>
        </div>
    );
}
